import React from "react";
import DragDropTable from "../components/DragDropTable";

function FantasyPool() {
  return (
    <>
      <DragDropTable />
    </>
  );
}

export default FantasyPool;
